// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface TrainingArtifactPayload
 */
export interface TrainingArtifactPayload {
    /**
     * Training session ID to which the artifact belongs
     * @type {number}
     * @memberof TrainingArtifactPayload
     */
    trainingSession: number;
    /**
     * Status of the captured step
     * @type {string}
     * @memberof TrainingArtifactPayload
     */
    status: TrainingArtifactPayloadStatusEnum;
    /**
     * Optional error context when status is fail
     * @type {string}
     * @memberof TrainingArtifactPayload
     */
    errorInfo?: string;
    /**
     * Zero-based index for the parent step
     * @type {number}
     * @memberof TrainingArtifactPayload
     */
    stepIndex: number;
    /**
     * Step type, `i` for interaction and `a` for assertion
     * @type {string}
     * @memberof TrainingArtifactPayload
     */
    stepType: TrainingArtifactPayloadStepTypeEnum;
    /**
     * Zero-based counter for nested steps
     * @type {number}
     * @memberof TrainingArtifactPayload
     */
    subStep?: number;
    /**
     * Human readable description of the sub-step
     * @type {string}
     * @memberof TrainingArtifactPayload
     */
    subStepTxt?: string;
    /**
     * URL of the full-size screenshot
     * @type {string}
     * @memberof TrainingArtifactPayload
     */
    imgFull?: string;
    /**
     * URL of the thumbnail screenshot
     * @type {string}
     * @memberof TrainingArtifactPayload
     */
    imgThumb?: string;
    /**
     * Timestamp when the action was executed
     * @type {string}
     * @memberof TrainingArtifactPayload
     */
    timestamp?: string;
    /**
     * Browser URL captured for the artifact
     * @type {string}
     * @memberof TrainingArtifactPayload
     */
    browserLocation?: string;
    /**
     * Free-form metadata such as AI thoughts
     * @type {{ [key: string]: any; }}
     * @memberof TrainingArtifactPayload
     */
    otherInfoJson?: { [key: string]: any; };
    /**
     * Optional override for the artifact creation timestamp
     * @type {string}
     * @memberof TrainingArtifactPayload
     */
    created?: string;
}

export function TrainingArtifactPayloadFromJSON(json: any): TrainingArtifactPayload {
    return {
        'trainingSession': json['training_session'],
        'status': json['status'],
        'errorInfo': !exists(json, 'error_info') ? undefined : json['error_info'],
        'stepIndex': json['step_index'],
        'stepType': json['step_type'],
        'subStep': !exists(json, 'sub_step') ? undefined : json['sub_step'],
        'subStepTxt': !exists(json, 'sub_step_txt') ? undefined : json['sub_step_txt'],
        'imgFull': !exists(json, 'img_full') ? undefined : json['img_full'],
        'imgThumb': !exists(json, 'img_thumb') ? undefined : json['img_thumb'],
        'timestamp': !exists(json, 'timestamp') ? undefined : json['timestamp'],
        'browserLocation': !exists(json, 'browser_location') ? undefined : json['browser_location'],
        'otherInfoJson': !exists(json, 'other_info_json') ? undefined : json['other_info_json'],
        'created': !exists(json, 'created') ? undefined : json['created'],
    };
}

export function TrainingArtifactPayloadToJSON(value?: TrainingArtifactPayload): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'training_session': value.trainingSession,
        'status': value.status,
        'error_info': value.errorInfo,
        'step_index': value.stepIndex,
        'step_type': value.stepType,
        'sub_step': value.subStep,
        'sub_step_txt': value.subStepTxt,
        'img_full': value.imgFull,
        'img_thumb': value.imgThumb,
        'timestamp': value.timestamp,
        'browser_location': value.browserLocation,
        'other_info_json': value.otherInfoJson,
        'created': value.created,
    };
}

/**
* @export
* @enum {string}
*/
export enum TrainingArtifactPayloadStatusEnum {
    Pass = 'pass',
    Fail = 'fail'
}
/**
* @export
* @enum {string}
*/
export enum TrainingArtifactPayloadStepTypeEnum {
    I = 'i',
    A = 'a'
}


